import { Link } from 'react-router-dom';
import { Clock, Repeat, CreditCard, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { clsx } from 'clsx';
import { formatDate } from '@utils/formatters';
import { formatCompact } from './dashboardHelpers';

const DashboardUpcoming = ({ upcomingPayments }) => {
  const now = new Date();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white">Próximos Pagamentos</h3>
          <p className="text-xs text-gray-400 mt-0.5">Próximos 30 dias</p>
        </div>
        <Link to="/app/transactions">
          <button className="text-xs text-primary-600 hover:text-primary-700 font-medium">
            Ver todos →
          </button>
        </Link>
      </div>
      {upcomingPayments.length > 0 ? (
        <div className="space-y-3">
          {upcomingPayments.map(item => {
            const daysUntil = Math.ceil(
              (new Date(item.date + 'T12:00:00') - now) / 86400_000
            );
            const isUrgent = daysUntil <= 3;
            const isOverdue = daysUntil < 0;
            return (
              <div key={item.id} className="flex items-center gap-3">
                <div className={clsx(
                  'w-9 h-9 rounded-xl flex-shrink-0 flex items-center justify-center',
                  isOverdue ? 'bg-red-100 dark:bg-red-900/30' :
                  isUrgent ? 'bg-orange-100 dark:bg-orange-900/30' :
                  item.source === 'recurrence' ? 'bg-purple-100 dark:bg-purple-900/30' :
                  'bg-orange-100 dark:bg-orange-900/30'
                )}>
                  {item.source === 'recurrence'
                    ? <Repeat size={15} className={isUrgent ? 'text-orange-600' : 'text-purple-600'} />
                    : item.source === 'installment'
                      ? <CreditCard size={15} className={isUrgent ? 'text-orange-600' : 'text-orange-600'} />
                      : <Clock size={15} className="text-red-600" />}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                    {item.description}
                  </p>
                  <div className="flex items-center gap-1.5 mt-0.5">
                    {isOverdue
                      ? <span className="text-xs text-red-600 font-semibold flex items-center gap-0.5"><AlertTriangle size={10} /> Atrasado</span>
                      : isUrgent
                        ? <span className="text-xs text-orange-600 font-semibold">Vence em {daysUntil}d</span>
                        : <span className="text-xs text-gray-400">{formatDate(item.date)}</span>}
                  </div>
                </div>
                <span className="text-sm font-bold text-red-600 flex-shrink-0">
                  {formatCompact(Math.abs(item.amount))}
                </span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-32 text-gray-400 gap-2">
          <CheckCircle2 size={28} className="text-emerald-400" />
          <p className="text-sm text-center">Nenhum pagamento nos próximos 30 dias</p>
        </div>
      )}
    </div>
  );
};

export default DashboardUpcoming;
